/**
 * Configuração agnóstica de requisição HTTP.
 * Compatível com qualquer cliente (Axios, Fetch, etc).
 */
export type ApiRequestConfig = {
  method?: string;
  url?: string;
  skipToastError?: boolean;
  customErrorTitle?: string;
  customErrorMessage?: string;
  expectedErrors?: unknown[];
};

/**
 * Resposta agnóstica de erro HTTP (nível de transporte).
 * Abstrai response.data, status e headers de qualquer cliente.
 */
export type ApiRequestErrorResponse = {
  data?: unknown;
  status?: number;
  statusText?: string;
  headers?: Record<string, unknown>;
};

/**
 * Erro agnóstico de requisição HTTP.
 * Usado para tratamento de erros independente do cliente (Axios, Fetch, etc).
 * Padronizado no @infor/api - as aplicações consomem sempre este tipo.
 */
export type ApiRequestError = {
  message: string;
  code?: string;
  response?: ApiRequestErrorResponse;
  requestConfig?: ApiRequestConfig;
  /** Erro original do cliente (AxiosError, etc) - para debug e compatibilidade */
  originalError?: unknown;
  readonly isApiRequestError?: true;
};

/**
 * Verifica se o erro é ApiRequestError normalizado (não AxiosError bruto).
 * Exige requestConfig para que AxiosError (que tem apenas config) não seja aceito.
 */
export const isApiRequestError = (
  error: unknown
): error is ApiRequestError & { response?: { data?: unknown } } =>
  typeof error === 'object' &&
  error !== null &&
  'message' in error &&
  typeof (error as ApiRequestError).message === 'string' &&
  'requestConfig' in error;
